var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTradingAccount = function SvgTradingAccount(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 15C30.0007 6.71573 23.285 -2.92514e-06 15.0007 -2.56302e-06C6.71646 -2.2009e-06 0.000731404 6.71573 0.000731766 15C0.000732128 23.2843 6.71646 30 15.0007 30C23.285 30 30.0007 23.2843 30.0007 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 30.001C23.285 30.001 30.0007 23.2852 30.0007 15.001C30.0007 6.71671 23.285 0.000976563 15.0007 0.000976563C6.71646 0.000976563 0.000732422 6.71671 0.000732422 15.001C0.000732422 23.2852 6.71646 30.001 15.0007 30.001Z",
    fill: "url(#paint0_radial_2137_7142)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 15C30.0007 6.71573 23.285 -1.01779e-06 15.0007 -6.55671e-07C6.71646 -2.93554e-07 0.000731404 6.71573 0.000731766 15C0.000732128 23.2843 6.71646 30 15.0007 30C23.285 30 30.0007 23.2843 30.0007 15Z",
    fill: "url(#paint1_linear_2137_7142)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 15C30.0007 6.71573 23.285 -1.01779e-06 15.0007 -6.55671e-07C6.71646 -2.93554e-07 0.000731404 6.71573 0.000731766 15C0.000732128 23.2843 6.71646 30 15.0007 30C23.285 30 30.0007 23.2843 30.0007 15Z",
    fill: "url(#paint2_radial_2137_7142)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2137_7142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8751 16.9834L18.4376 13.8897C18.2488 13.7198 18.004 13.6256 17.7501 13.625H12.2501C11.9961 13.6256 11.7513 13.7198 11.5626 13.8897L8.12508 16.9834C7.95148 17.1396 7.83601 17.35 7.79754 17.5803C7.75907 17.8106 7.7999 18.0471 7.91333 18.2512L9.63208 21.3449C9.765 21.584 9.98744 21.7604 10.2505 21.8355C10.5135 21.9105 10.7955 21.878 11.0346 21.7451C11.2736 21.6121 11.4501 21.3897 11.5251 21.1267C11.6001 20.8637 11.5676 20.5816 11.4347 20.3426L10.1133 17.9666L11.5626 16.6624V22.5625C11.5626 22.7448 11.635 22.9197 11.7639 23.0486C11.8929 23.1776 12.0677 23.25 12.2501 23.25H17.7501C17.9324 23.25 18.1073 23.1776 18.2362 23.0486C18.3651 22.9197 18.4376 22.7448 18.4376 22.5625V16.6624L19.8868 17.9686L18.5675 20.3446C18.5017 20.463 18.4598 20.5932 18.4443 20.7277C18.4288 20.8622 18.44 20.9985 18.4771 21.1287C18.5143 21.259 18.5767 21.3806 18.6609 21.4867C18.745 21.5928 18.8493 21.6813 18.9676 21.7471C19.086 21.8129 19.2162 21.8548 19.3507 21.8703C19.4852 21.8858 19.6215 21.8747 19.7518 21.8375C19.882 21.8004 20.0036 21.7379 20.1097 21.6538C20.2158 21.5696 20.3043 21.4654 20.3701 21.347L22.0889 18.2533C22.2026 18.0487 22.2434 17.8116 22.2045 17.5809C22.1657 17.3501 22.0495 17.1394 21.8751 16.9834Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.25C16.5188 12.25 17.75 11.0188 17.75 9.5C17.75 7.98122 16.5188 6.75 15 6.75C13.4812 6.75 12.25 7.98122 12.25 9.5C12.25 11.0188 13.4812 12.25 15 12.25Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2137_7142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62503 22.4999C12.3591 22.4999 20.25 14.6089 20.25 4.87489C20.25 3.46315 20.0841 2.09017 19.7705 0.774414C25.7161 2.7674 30 8.38336 30 14.9999C30 23.2842 23.2843 29.9999 15 29.9999C9.44343 29.9999 4.59251 26.9785 2.00049 22.489C2.20778 22.4963 2.41598 22.4999 2.62503 22.4999Z",
    fill: "url(#paint3_linear_2137_7142)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2137_7142",
    x: 0.667155,
    y: -0.558919,
    width: 30.6662,
    height: 31.8923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2137_7142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2137_7142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2137_7142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9453 -4.75482e-05) rotate(135) scale(26.2404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_7142",
    x1: 13.7507,
    y1: -2.5,
    x2: 0.000730471,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2137_7142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5 7.125) rotate(143.291) scale(35.5496 29.3442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_7142",
    x1: 16.0041,
    y1: 29.9999,
    x2: 19.7477,
    y2: 8.84723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2137_7142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(6.75 6.75)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTradingAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trading-account.44261eb4.svg";
export { ForwardRef as ReactComponent };